import Vue from 'vue'
import Loading from '@/components/Loading.vue'

export default {
  install(Vue) {
    // 注册Loading组件为全局组件
    Vue.component('Loading', Loading)
    
    // 添加全局方法
    Vue.prototype.$setLoading = function(elementId, isLoading) {
      if (isLoading) {
        // 如果已经存在加载组件，则不重复添加
        if (document.getElementById(`loading-${elementId}`)) return;
        
        // 创建加载组件实例
        const LoadingComponent = Vue.extend(Loading);
        const instance = new LoadingComponent();
        
        // 挂载组件
        instance.$mount();
        
        // 给加载组件添加ID以便后续移除
        instance.$el.id = `loading-${elementId}`;
        
        // 找到目标元素并添加加载组件
        const targetElement = document.getElementById(elementId);
        if (targetElement) {
          // 添加相对定位，确保loading组件能够正确定位
          if (getComputedStyle(targetElement).position === 'static') {
            targetElement.style.position = 'relative';
          }
          targetElement.prepend(instance.$el);
        } else {
          console.warn(`目标元素 #${elementId} 不存在，无法添加loading`);
        }
      } else {
        // 移除加载组件
        const loadingElement = document.getElementById(`loading-${elementId}`);
        if (loadingElement) {
          loadingElement.remove();
        }
      }
    }
  }
}